+
<script setup lang="ts">
// eslint-disable-next-line no-unused-vars
import {useTemplateRef, defineProps, computed, defineEmits} from "vue";
import BaseModal from "@/components/modals/BaseModal.vue";
import {IDriver} from "@/interfaces/IDriver";

const props = defineProps<{
  drivers: IDriver[],
  selected: Array<number>,
  filterName: String
}>();

const emits = defineEmits(['toggleDrivers', 'filter:name']);

const setDrivers = (e: any, id: number) => emits('toggleDrivers', {
  status: e.target.checked,
  id
});

const modal = useTemplateRef('driver-modal');
</script>

<template>
  <BaseModal>
    <template v-slot:modal>
      <div ref="driver-modal" class="modal fade" id="selectCarModal" tabindex="-1" aria-labelledby="exampleModalLabel"
           aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                Выбор водителя
              </h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="w-100">
                Фильтр по ФИО
                <input :value="filterName" @input="e => emits('filter:name', e)" type="text" class="form-control form-control-sm">
              </label>
              <div v-for="(driver, i) in props.drivers" :key="i" class="form-check">
                <label class="form-check-label" :for="driver.id">
                  {{ driver.name }}
                </label>
                <input @change="(event) => setDrivers(event, driver.id)"
                       :checked="selected.find(id => id === driver.id)" :value="driver.id" class="form-check-input"
                       type="radio" name="drivers"
                       :id="driver.id">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Закрыть</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:action="{open}">
      <slot name="action" :open="() => open(modal)"></slot>
    </template>
  </BaseModal>
</template>
